
const stringToDate = value => value.length === 10 ? new Date(`${value}T00:00:00.000-03:00`) : new Date(value)

export default class Formatter {
  static centsToPrice(cents) {
    if (typeof cents !== 'number') return ''
    return (cents / 100).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
  }

  static cnpj(value) {
    if (!value) return ''

    return value.replace(/([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }

  static cpf(value) {
    if (!value) return ''

    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }

  static cpfCnpj(value) {
    if (!value) return ''

    const stringValue = String(value)
    const alphanumeric = stringValue.replace(/[^0-9A-Za-z]/g, '')
    if (alphanumeric.length === 14) return Formatter.cnpj(alphanumeric)
    const digits = stringValue.replace(/\D/g, '')
    if (digits.length === 11) return Formatter.cpf(digits)
    return value
  }

  static stringToDate(value) {
    if (!value) return ''

    try {
      const date = stringToDate(value)
      return date.toLocaleDateString()
    } catch (e) { return '' }
  }

  static stringToDatetime(value) {
    if (!value) return ''

    try {
      const date = stringToDate(value)
      return date.toLocaleString()
    } catch (e) { return '' }
  }

    static phone(value) {
      if (!value) return ''

      if (value.length !== 10 && value.length !== 11) return ''
      return value.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')
    }
}
